import React from 'react';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '../../../../types/resource';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import GroupCard from '../../../../GroupCard';
import s from './Groups.scss';
var Groups = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement("div", { className: s['grid'] }, (_b = block.groups) === null || _b === void 0 ? void 0 : _b.map(function (group, index) { return (React.createElement(GroupCard, { key: group.userId, username: group.username, imageUrl: group.usericon, className: s['grid-item'], biData: {
                evid: BiEventType.USERNAME_CLICK,
                typeid: ResourceType.GROUP,
                itemid: group.userId,
                _rankIndex: index,
            } })); }))));
};
Groups.displayName = 'Groups';
export default Groups;
//# sourceMappingURL=Groups.js.map